__turbopack_context__.v({
  "badgeDev": "PortalSelector-module__X9x2NW__badgeDev",
  "badgeLocal": "PortalSelector-module__X9x2NW__badgeLocal",
  "badgeProd": "PortalSelector-module__X9x2NW__badgeProd",
  "body": "PortalSelector-module__X9x2NW__body",
  "close": "PortalSelector-module__X9x2NW__close",
  "footerNote": "PortalSelector-module__X9x2NW__footerNote",
  "header": "PortalSelector-module__X9x2NW__header",
  "headerText": "PortalSelector-module__X9x2NW__headerText",
  "item": "PortalSelector-module__X9x2NW__item",
  "itemDesc": "PortalSelector-module__X9x2NW__itemDesc",
  "itemHere": "PortalSelector-module__X9x2NW__itemHere",
  "itemLabel": "PortalSelector-module__X9x2NW__itemLabel",
  "itemTop": "PortalSelector-module__X9x2NW__itemTop",
  "kicker": "PortalSelector-module__X9x2NW__kicker",
  "list": "PortalSelector-module__X9x2NW__list",
  "meta": "PortalSelector-module__X9x2NW__meta",
  "panel": "PortalSelector-module__X9x2NW__panel",
  "pill": "PortalSelector-module__X9x2NW__pill",
  "pillDev": "PortalSelector-module__X9x2NW__pillDev",
  "pillEmp": "PortalSelector-module__X9x2NW__pillEmp",
  "pillLab": "PortalSelector-module__X9x2NW__pillLab",
  "pillOps": "PortalSelector-module__X9x2NW__pillOps",
  "pillProd": "PortalSelector-module__X9x2NW__pillProd",
  "primaryBtn": "PortalSelector-module__X9x2NW__primaryBtn",
  "primaryHint": "PortalSelector-module__X9x2NW__primaryHint",
  "primaryLabel": "PortalSelector-module__X9x2NW__primaryLabel",
  "scrim": "PortalSelector-module__X9x2NW__scrim",
  "sectionLabel": "PortalSelector-module__X9x2NW__sectionLabel",
  "sub": "PortalSelector-module__X9x2NW__sub",
  "tab": "PortalSelector-module__X9x2NW__tab",
  "tabBadge": "PortalSelector-module__X9x2NW__tabBadge",
  "tabOpen": "PortalSelector-module__X9x2NW__tabOpen",
  "title": "PortalSelector-module__X9x2NW__title",
});
